const blog = {
  blogPage: {
    header: {
      overline: "ANALYSES & PERSPECTIVES",
      titlePrefix: "Les chroniques de la",
      titleHighlight: "data",
      titleSuffix: "",
      subtitle: "Analyses approfondies sur la Data Science, l’architecture IA et la construction de logiciels intelligents.",
    },
    actions: {
      readArticle: "Lire l’article",
    },
    newsletter: {
      titlePrefix: "Abonnez-vous aux",
      titleHighlight: "analyses approfondies",
      subtitle: "Recevez nos meilleures analyses sur l’IA et l’architecture technique. Pas de spam, que de la valeur.",
      namePlaceholder: "Votre nom",
      emailPlaceholder: "Votre adresse email",
      buttonIdle: "Rejoindre la communauté",
      buttonLoading: "Chargement...",
    },
    validation: {
      requiredFields: "Veuillez remplir tous les champs.",
    },
    modal: {
      titles: {
        success: "Succès !",
        warning: "Attention",
        error: "Erreur",
      },
      close: "Fermer",
      messages: {
        success: "Ravi de vous compter parmi nous, {{name}} ! Vous recevrez bientôt nos meilleures analyses.",
        alreadySubscribed: "Vous êtes déjà inscrit à notre newsletter !",
      },
    },
  },
  blogDetail: {
    errors: {
      load: "Erreur lors du chargement de l’article",
    },
    backToBlog: "Retour au blog",
    suggested: {
      title: "Vous pourriez aussi aimer",
      readMore: "Lire la suite",
    },
    footerCta: {
      titlePrefix: "Prêt à approfondir votre",
      titleHighlight: "expertise data ?",
      subtitle:
        "Implémentations IA avancées ou conseil stratégique : je vous aide à naviguer dans un monde data complexe et à produire de l’impact.",
      primaryButton: "Planifier un appel gratuit",
      secondaryButton: "Explorer les services",
    },
  },
};

export default blog;
